const $productsContainer = $("#products-container");
const productsRef = database
  .ref("/products/")
  .orderByChild("/status/")
  .equalTo("pubblico");
const categoriesRef = database.ref("/categories/");
const ordersRef = database.ref("/orders/");

let products;
let productVersion;
let cart;
let order = {};
let myOrders = {};
let categories;
let shippingCost = getShippingCost();

let $cartTotPreview = $("#cart-tot-preview");
let paypalObj;

var country_list = [
  "Austria",
  "Azzorre",
  "Belgium",
  "Bulgaria",
  "Cyprus",
  "Czech Republic",
  "Croazia",
  "Denmark",
  "Estonia",
  "Finland",
  "France",
  "France-Corsica",
  "Germany",
  "Greece",
  "Ireland",
  "Italy",
  "Latvia",
  "Liechtestein",
  "Luxembourg",
  "Netherlands",
  "Norway",
  "Malta",
  "Poland",
  "Portugal",
  "Portugal-Madera",
  "Romania",
  "Serbia",
  "Slovakia",
  "Slovenia",
  "Spain",
  "Spain-Baleari",
  "Spain-Canarie-Andorra-Ceuta-Melilla-Gibilterra",
  "Sweden",
  "Switzerland",
  "Turkey",
  "Ungheria",
  "UK-London",
  "UK-Scotland-Irland",
  "UK-Rest-of-country",
];

//cart management

if (!localStorage.getItem("cart")) {
  cart = {
    productList: [],
    shippingCost: 0,
    shippingType: "Corriere espresso 48/72H",
    tot: 0
  };
  localStorage.setItem("cart", JSON.stringify(cart));
  cart = JSON.parse(localStorage.getItem("cart"));
} else {
  cart = JSON.parse(localStorage.getItem("cart"));
}

const addProductToCart = id => {
  let product = products[id];
  cart.productList.push({
    ui_seq_id: product.id + "-" + cart.productList.length,
    product_id: product.id,
    name: product.title,
    size: $("#pent-size").val(),
    price: product.price.toFixed(2)
  });
  cart.tot += product.price;
  localStorage.setItem("cart", JSON.stringify(cart));
  closeModal();
};

const removeProductFromCart = seqId => {
  cart.productList.forEach((product, index) => {
    if (seqId === product.ui_seq_id) {
      cart.productList.splice(index, 1);
      cart.tot -= product.price;
      $(`#${seqId}`).next("hr").remove();
      $(`#${seqId}`).remove();
      closeModal();
      if (cart.productList.length === 0) {
        cart.productList = [];
        cart.shippingCost = 0;
      } else {
        openCartModal();
      }
    }
  });
  localStorage.setItem("cart", JSON.stringify(cart));
};

const emptyCart = () => {
  cart = {
    productList: [],
    shippingCost: 0,
    shippingState: {
      country: "Italy",
      carriers: "bartolini espresso",
      trackingLink: "brt.it",
      trackingNUmber: false
    },
    tot: 0
  };
  localStorage.setItem("cart", JSON.stringify(cart));
  cart = JSON.parse(localStorage.getItem("cart"));
};

const shippingRef = database.ref("/shippings/Italy");
shippingRef.on("value", snapshot => {
  let shipping = snapshot.val();
  if (shipping) {
    shippingCost = Number(shipping.price).toFixed(2);
    cart.shippingState = {
      country: shipping.country,
      carriers: shipping.country,
      trackingLink: shipping.trackingLink,
      trackingNUmber: false
    };
    localStorage.setItem("cart", JSON.stringify(cart));
    cart = JSON.parse(localStorage.getItem("cart"));
  } else {
    shippingCost = Number(12.50).toFixed(2);
    cart.shippingState = {
      country: "Italy",
      carriers: "GLS",
      trackingLink: "www.gls.com",
      trackingNUmber: false
    };
    cart = JSON.parse(localStorage.getItem("cart"));
  }
});

setInterval(() => {
  const tot = Number(cart.tot);
  const realShippingCost = Number(getShippingCost());
  $cartTotPreview.text(Number(tot + realShippingCost).toFixed(2));
  cart.shippingCost = cart.productList.length === 0 ? 0 : Number(shippingCost).toFixed(2);;
}, 200);

const getProductAvailableSizes = sizes => {
  let sizesList = "";
  if (sizes !== null && sizes !== undefined) {
    let sizesKeys = Object.keys(sizes);
    let sizesLength = sizesKeys.length;
    sizesKeys.forEach((sizeKey, index) => {
      if (sizes[sizeKey] > 0) {
        sizesList += sizeKey;
        if (index + 1 !== sizesLength) {
          sizesList += ",";
        }
      }
    });
  } else {
    sizesList = "nessuna taglia disponibile";
  }
  return sizesList;
};

const getAvailableStat = sizes => {
  let count = 0;
  let available = null;
  if (sizes !== null && sizes !== undefined) {
    let sizesKeys = Object.keys(sizes);
    sizesKeys.forEach(sizeKey => {
      if (sizes[sizeKey] !== 0) {
        available++;
      }
    });
  }
  if (available > 0) {
    available = true;
  } else {
    available = false;
  }
  return available;
};

const goToProduct = id => {
  window.location = "/shop/product/?id=" + id.toString();
};

const getProductTemplate = product => {
  products[product.id].sizes = product.sizes;
  const showSoldOut = getAvailableStat(product.sizes) ? "none" : "block";
  const soldOutClass = getAvailableStat(product.sizes) ? null : "sold-out-product";

  return `
    <div class="product-col cat-${product.category} subCat-${product.subCategory} col-12 col-sm-6 col-md-4 col-lg-3 p-0 pb-4 p-sm-4">
        <div
          class="product-container ${soldOutClass}"
          onclick="openProductModal('${product.id}')"
        >
          <div class="${soldOutClass}">
            <div class="product-image-container">
              <img
                class="product-cover"
                style="width: 100%; height: auto;" src="${product.img}"
              >
            </div>
            <div class="product-label">
              <h4>
                <small>${product.title} (${product.subCategory})</small>
              </H4>
              <hr class="m-0"/>
              <p class="m-0">
                <small>
                  <strong>Taglie:</strong>
                  ${getProductAvailableSizes(product.sizes)}
                </small>
              </p>
            </div>
            <div class="product-price text-center">
              <h4><small><strong>${product.price.toFixed(
                2
              )}€</strong></small></h4>
              <img
                class="lab-img"
                src="/assets/images/ui/price-lab.png"
              >
            </div>
          </div>
          <img
            class="sold-out-img"
            style="display:${showSoldOut}"
            src="/assets/images/ui/sold-out.png"
          >
      </div>
    <div>
  `;
};

const isActiveCatFilter = index => {
  let active;
  if (index === 0) {
    active = "active";
  }
  return active;
};

const renderCatFilters = () => {
  let catFilterBar = "";
  categoriesRef.once("value", snapshot => {
    categories = snapshot.val();
    let categoriesKeys = Object.keys(categories);
    renderSubCatFilters(categoriesKeys[0]);
    categoriesKeys.forEach((categoryKey, index) => {
      catFilterBar += `<li class="filter-cat filter-cat-${categoryKey} ${isActiveCatFilter(
        index
      )}"  onClick="filterCatProducts('${categoryKey}')"><small>${categoryKey}</small></li>`;
    });
    $(".shop-cat-filters").html("");
    $(".shop-cat-filters").append(catFilterBar);
  });
};

const renderSubCatFilters = categoryKey => {
  let subCatFilterBar = "";
  categoriesRef
    .child(categoryKey + "/subCategories/")
    .once("value", snapshot => {
      let subCategories = snapshot.val();
      let subCategoriesKeys = Object.keys(subCategories);
      subCategoriesKeys.forEach((subCategoryKey, index) => {
        subCatFilterBar += `<li class="filter-subCat filter-subCat-${
          subCategories[subCategoryKey]
        }"} onClick="filterSubCatProducts('${
          subCategories[subCategoryKey]
        }')"><small>${subCategories[subCategoryKey]}</small></li>`;
      });
      $(".filter-subCat")
        .not(".filter-subCat-all")
        .remove();
      $(".shop-subCat-filters").append(subCatFilterBar);
    });
};

const filterCatProducts = category => {
  if (category === "all") {
    $(".product-col").css("display", "block");
    $(".filter-cat")
      .not("filter-cat-all")
      .removeClass("active");
    $(".filter-cat-all").addClass("active");
    $(".shop-cat-filters")
      .not("filter-subCat-all")
      .remove();
  } else {
    $(".cat-" + category).css("display", "block");
    $(".product-col")
      .not(".cat-" + category)
      .css("display", "none");
    $(".filter-cat")
      .not(".filter-cat-" + category)
      .removeClass("active");
    $(".filter-cat-" + category).addClass("active");
    renderSubCatFilters(category);
  }
};

const filterSubCatProducts = subCategory => {
  if (subCategory === "all") {
    $(".product-col").css("display", "block");
    $(".filter-subCat")
      .not("filter-subCat-all")
      .removeClass("active");
    $(".filter-subCat-all").addClass("active");
  } else {
    $(".subCat-" + subCategory).css("display", "block");
    $(".product-col")
      .not(".subCat-" + subCategory)
      .css("display", "none");
    $(".filter-subCat")
      .not(".filter-subCat-" + subCategory)
      .removeClass("active");
    $(".filter-subCat-" + subCategory).addClass("active");
  }
};

const viewOrder = sku => {
  window.location = "/shop/orders/view/index.php?sku=" + sku;
};

const getOrderListTemplate = order => {
  let orderListTemplate = "";
  order.productList.forEach((product, index) => {
    orderListTemplate += `
            <div class="row cart-item" id="${product.ui_seq_id}">
                <div class="col-9 text-left">
                    <p>${product.name}(Taglia ${product.size})</p>
                </div>
                <div class="col-3 text-right">
                    <p>${product.price}&euro;</p>
                </div>
            </div>
        `;
    if (index + 1 !== order.productList.length) {
      orderListTemplate += '<hr style="margin-top:2px; margin-bottom:2px">';
    } else {
      orderListTemplate += '<hr style="margin-top:2px; margin-bottom:2px">';
      orderListTemplate += "<br>";
    }
  });
  orderListTemplate += `
        <div class="row cart-item">
            <div class="col-8 text-right">
                <p>Spese di spedizione</p>
            </div>
            <div class="col-4 text-right">
                <p>${Number(order.shippingCost).toFixed(2)}&euro;</p>
            </div>
        </div>
  `;
  if(hasSale()) {
    orderListTemplate += `
        <div class="row cart-item">
            <div class="col-8 text-right text-green">
                <p>Sconto quantità</p>
                <p class="sale-text">Ogni 3 infradito la spedizione è gratis!</p>
            </div>
            <div class="col-4 text-right" style="color: green">
                <p>-${Number(order.shippingCost).toFixed(2)}€</p>
            </div>
        </div>
  `;
  }
  orderListTemplate += `<hr style="margin-top:2px; margin-bottom:2px">
        <div class="row">
            <div class="col-8 text-right">
                <p>Totale(Iva inc.)</p>
            </div>
            <div class="col-4 text-right">
                <p>${(Number(order.tot) + getShippingCost()).toFixed(2)}€</p>
            </div><br><br><br>
        </div>
    `;
  return orderListTemplate;
};

const getOrderInfoTemplate = (order, sku) => {
  return `
      <p class="pb-0 mt-0"><strong>Numero Ordine</strong></p>
      <p class="pb-0 mt-0">${sku}</p>
      <div style="height: 8px"></div>
      <p class="pb-0 mt-0"><strong>Stato</strong></p>
      <p class="pb-0 mt-0">${order.state}</p>
      <div style="height: 8px"></div>
      <p class="pb-0 mt-0"><strong>Data</strong></p>
      <p class="pb-0 mt-0">${getDateFromTimestamp(order)}</p>
      <div style="height: 8px"></div>
  `;
};

const getShippingTemplate = (order, sku) => {
  return `
    <p class="pb-0 mt-0"><strong>Indirizzo</strong></p>
    <p class="pb-0 mt-0">
      ${order.userInfo.fullName}
    </p>
    <p class="pb-0 mt-0">
      ${order.userInfo.address.addressLine}, ${order.userInfo.address.addressLineB}
    </p>
    <p class="pb-0 mt-0">
      ${order.userInfo.address.zip}, ${order.userInfo.address.city}, ${order.userInfo.address.state}
    </p>
    <div style="height: 8px"></div>
    <p class="pb-0 mt-0"><strong>Corriere</strong></p>
    <p class="pb-0 mt-0">
      ${getTrackingNumber(order.shippingState.carriers)}
    </p>
    <p class="pb-0 mt-0"><strong>Link Tracking</strong></p>
    <p class="pb-0 mt-0">
      ${getTrackingNumber(order.shippingState.trackingLink)}
    </p>
    <p class="pb-0 mt-0"><strong>Tracking Number</strong></p>
    <p class="pb-0 mt-0">
      ${getTrackingNumber(order.shippingState.trackingNumber)}
    </p>
  `;
};

const getTrackingNumber = tracking => {
  return tracking ? tracking : "non ancora fornito";
};

function hasSale() {
  if(!cart || !cart.shippingState) {
    return false;
  }
  
  const shipping = {
    country: cart.shippingState.country
  }

  if(shipping.country.toLowerCase() === 'italy') {
    return cart.productList.length % 3 === 0;
  }

  return false;
}

function getShippingCost() {  
  if(hasSale()) {
    return 0;
  }

  return cart && cart.shippingCost ? Number(cart.shippingCost).toFixed(2) : 0;
};

function onStateChange() {
  const shippingRef = database.ref("/shippings/" + $('#state').val());
  shippingRef.on("value", snapshot => {
    let shipping = snapshot.val();
    if (shipping) {
      shippingCost = Number(shipping.price).toFixed(2);
      userInfo.address.country = $('#state').val();
      const userRef = database.ref('users/' + userInfo.uid + '/address/country/');
      userRef.set(shipping.country).then(() => {
        cart.shippingState = {
          country: shipping.country,
          carriers: shipping.name,
          trackingLink: shipping.trackingLink,
          trackingNUmber: false
        };
        
        localStorage.setItem("cart", JSON.stringify(cart));
        cart = JSON.parse(localStorage.getItem("cart"));
        closeModal();
        openCheckoutModal();
        $('#state').val(shipping.country);
        // closeModal();
        // setTimeout(() => {
        //   openCheckoutModal();
        //   $('#state').val(shipping.country);
        // }, 0);
      });
    } else {
      shippingCost = Number(12.50).toFixed(2);
      userInfo.address.country = $('#state').val();
      const userRef = database.ref('users/' + userInfo.uid + '/address/country/');
      userRef.set(shipping.country).then(() => {
        cart.shippingState = {
          country: shipping.country,
          carriers: "GLS",
          trackingLink: "www.gls.com",
          trackingNUmber: false
        };
        localStorage.setItem("cart", JSON.stringify(cart));
        cart = JSON.parse(localStorage.getItem("cart"));
        closeModal();
        openCheckoutModal();
        $('#state').val(shipping.country);
        // closeModal();
        // setTimeout(() => {
        //   openCheckoutModal()
        //   $('#state').val(shipping.country)
        // },0);
      }); 
    }
  });
}

/**
 * Rimuove eventualmente il tasto per effettuare il pagamento con paypal
 * (Usato durante la validazione del carrello)
 */
const removeOrderCheckout = () => {
  return $('#pay-button').empty();
}

const createOrderCheckout = () => {
  // Creare oggetto database
  order = Object.assign(cart);
  order.userInfo = Object.assign(userInfo);
  order.state = "nuovo";
  order.userUid = userInfo.uid;
  order.userFullName = userInfo.fullName;
  order.timestamp = getMillisecondStamp();
  order.userInfo.address = {
    fullName: $("#fullName").val(),
    addressLine: $("#addressLine").val(),
    addressLineB: $("#addressLineB").val(),
    city: $("#city").val(),
    zip: $("#zip").val(),
    state: $("#state").val(),
    telephone: $("#telephone").val()
  };
  // Creare oggetto paypal
  let data = {};

  const realShippingCost = getShippingCost();

  data.item_list = {};
  data.item_list.items = [];
  data.item_list.shipping_address = {
    recipient_name: $("#fullName").val(),
    line1: $("#addressLine").val(),
    city: $("#city").val(),
    postal_code: $("#zip").val(),
    phone: "346378737",
    state: "it"
  };

  order.productList.forEach(product => {
    data.item_list.items.push({
      name: product.name,
      description: "prodotto pentumas originale",
      quantity: "1",
      price: product.price,
      tax: "0",
      sku: "1",
      currency: "EUR"
    });
  });

  if(realShippingCost !== 0) {
    data.item_list.items.push({
      name: "Spese di spedizione",
      description: "Spese di spedizione",
      quantity: "1",
      price: realShippingCost,
      tax: "0",
      sku: "0002",
      currency: "EUR"
    });
  }

  data.amount = {
    total: (Number(order.tot) + Number(realShippingCost)).toFixed(2),
    currency: "EUR"
  };

  paypalObj = data;
  console.log(data);
  setPaypalCheckout();
};

const setPaypalCheckout = () => {
  paypal.Button.render({
      // Set your environment
      env: window.location.href.indexOf('pentumas.local') >= 0 ? "sandbox" : "production", // sandbox | production

      // Specify the style of the button
      style: {
        layout: "vertical", // horizontal | vertical
        size: "medium", // medium | large | responsive
        shape: "rect", // pill | rect
        color: "gold" // gold | blue | silver | white | black
      },

      client: {
        sandbox: "AamWYW07PAzTyS7QrKI4HexRkRZRwOO7Helr3OA15qP_Dty7nq6KIa8mwV8Rkyl_-8y_4yFIpDSWbglS",
        production: "AWdKY4ATcXHsH4NuBArfHBJlwhxuMfkmAIe1TjKyiyZK12G31gq9kKAFqdDyIOugXBRQ92qbQJyhhBIx"
      },

      payment: function(data, actions) {
        return actions.payment.create({
          payment: {
            transactions: [
              {
                amount: {
                  total: paypalObj.amount.total,
                  currency: "EUR"
                },
                item_list: paypalObj.itemList
              }
            ]
          }
        });
      },

      onAuthorize: function(data, actions) {
        console.log(data, actions);
        return actions.payment.execute().then(function() {
          order.productList.forEach(product => {
            const productRef = database.ref(
              "/products/" + product.product_id + "/sizes/" + product.size
            );
            productRef.once("value", snapshot => {
              productRef.set(Number(snapshot.val() - 1));
            });
          });
          ordersRef.push(order).then(snapshot => {
            let userOrder = {
              timestamp: order.timestamp,
              state: order.state,
              tot: (Number(order.tot) + Number(order.shippingCost)).toFixed(2),
              sku: snapshot.key
            };
            userRef
              .child("/orders/" + snapshot.key)
              .set(userOrder)
              .then(() => {
                emptyCart();
                closeModal();
              });
          });
        });
      }
    }, "#pay-button");
};

if (page === "shop") {
  renderCatFilters();
  productsRef.on("value", productsShot => {
    const productsValue = productsShot.val();
    products = productsValue;
    let productsKeys = Object.keys(products);
    $productsContainer.html("");
    productsKeys.forEach(key => {
      let currentProduct = products[key];
      currentProduct.id = key;
      $productsContainer.append(getProductTemplate(currentProduct));
    });
  });
}

if (page === "orders") {
  $(".filter-menu").css("display", "none");
  window.addEventListener("userLogged", function() {
    const clientOrdersRef = database.ref("users/" + userInfo.uid + "/orders/");
    clientOrdersRef
      .once("value", function(snapshot) {
        myOrders = Object.values(snapshot.val());
        if (myOrders !== undefined) {
          $(".no-orders-warning").addClass("d-none");
          $(".my-orders-table").removeClass("d-none");
          myOrders.forEach(order => {
            let orderRow = `
                        <tr class="my-orders-row" onClick="viewOrder('${
                          order.sku
                        }')">
                            <td><small>${order.sku}</small></td>
                            <td><small>${order.state}</small></td>
                            <td><small>${Number(order.tot).toFixed(
                              2
                            )}</small></td>
                            <td><small>${getDateFromTimestamp(
                              order
                            )}</small></td>
                        </tr>
                    `;
            $(".my-orders-tableBody").append(orderRow);
          });
        }
      })
      .then(function(error) {
        console.log(error);
      });
  });
}

if (page === "orderView") {
  $(".filter-menu").css("display", "none");
  if (getParameterByName("sku", window.location) !== undefined && getParameterByName("sku", window.location) !== null) {
    let orderSku = getParameterByName("sku", window.location.href);
    const orderRef = database.ref("/orders/" + orderSku);
    orderRef
      .once("value", snapshot => {
        $(".order-overview").append(getOrderListTemplate(snapshot.val()));
        $(".order-overview-info").append(
          getOrderInfoTemplate(snapshot.val(), orderSku)
        );
        $(".order-overview-address").append(
          getShippingTemplate(snapshot.val(), orderSku)
        );
      })
      .catch(error => {
        window.location = "/shop/";
      });
  } else {
    window.location = "/shop/";
  }
}
